<!--

UserDropdown component shows user avatar or user initials if avatar is not set.
On click it shows the user dropdown with basic user settings.

@param availabilityToggleShown boolean Flag which shows/hides the user status and status change option in the dropdown.
@param size String Defines the css class for user button size.

-->

<template>
  <b-dropdown
    no-caret
    right
    no-flip
    toggle-class="dropdown-menu-toggle"
    menu-class="menu-items"
    class="sb-dropdown-menu user-dropdown no-hover-box"
    :class="size">

    <!-- Button content -->
    <template slot="button-content">
      <SBAvatar
        :size="size"
        :show-availability-status="true"/>
    </template>

    <!-- Availability toggle -->
    <b-dropdown-header v-if="availabilityToggleShown">
      <SBAvatar
        :size="size"
        :show-data="true"
        :show-availability-toggle="true"/>
    </b-dropdown-header>

    <!-- Items -->
    <b-dropdown-divider/>
    <b-dropdown-item
      :to="{ name: 'Settings', params: { back_to: $route.path } }">
      <span class="icon account"/>
      <span class="text">Account</span>
    </b-dropdown-item>

    <template v-if="showBusinessList">
      <b-dropdown-divider/>
      <b-dropdown-item
        v-if="availabilityToggleShown"
        :to="{ name: 'BusinessList'}">
        <span class="icon business"/>
        <span class="text">My Businesses</span>
      </b-dropdown-item>
    </template>

    <template v-if="showOrganisationList">
      <b-dropdown-divider/>
      <b-dropdown-item
        v-if="availabilityToggleShown"
        :to="{ name: 'OrganisationList'}">
        <span class="icon business"/>
        <span class="text">My Organisations</span>
      </b-dropdown-item>
    </template>

    <b-dropdown-divider/>
    <b-dropdown-item @click="logout">
      <span class="icon logout"/>
      <span class="text">Log Out</span>
    </b-dropdown-item>

  </b-dropdown>
</template>

<script>
import { mapActions } from 'vuex';
import UserAvailabilityMixin from '@/mixins/UserAvailability';
import SBAvatar from './Avatar';
import UserDropdownButtonSize from '../../helpers/lists/userDropdownButtonSize';

export default {
  name: 'UserDropdown',
  components: {
    SBAvatar,
  },
  mixins: [UserAvailabilityMixin],
  props: {
    availabilityToggleShown: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: UserDropdownButtonSize.M,
    },
  },
  computed: {
    showBusinessList() {
      return (this.$route.name !== 'BusinessList');
    },
    showOrganisationList() {
      return (this.$route.name !== 'OrganisationList');
    },
  },
  mounted() {},
  methods: {
    ...mapActions({
      logout: 'user/logout',
    }),
  },
};
</script>

<style lang="scss" scoped>
.user-dropdown {
  .dropdown-menu {
    .dropdown-header {
      padding: 16px 12px 12px !important;
    }
  }
}

.sb-dropdown-menu::v-deep  {
  .user-avatar {
    background: $cadetBlue no-repeat 50% 50%;
    background-size: cover;
    color: $white;
    border-radius: 50%;
    font-weight: 500;

    &.add-hover-overlay:hover::after, &.add-hover-overlay.active {
      position: absolute;
      background: $blackPrimary;
      content: "";
      width: 100%;
      height: 100%;
      border-radius: 50%;
      opacity: 0.2;
    }

    @import '../../assets/css/modules/partials/indicator';
  }
}
</style>
